import * as calendarModel from '@app/pcs/models';
import { Calendar, CalendarMonth, CalendarPredicate, DayPredicate, ValidityPeriod } from '@app/pcs/models';
import * as R from 'ramda';

export const prepareCalendarToSave: any = (calendar: any) => {
  if (!calendar) {
    return;
  }

  const getDays = R.map(R.pickAll(['selected', 'selectable', 'editable']));
  const isNotOut = R.complement(R.prop('out'));
  const calendarProps = R.pickAll(['ttpFirstDate', 'ttpLastDate', 'validityPeriod', 'totalDays', 'ttpId'], calendar);
  const getAllDays: any = R.compose(R.flatten, R.map(R.prop('days')));

  return R.mergeRight(calendarProps, {
    targetId: calendar.id || 1,
    days: getDays(R.filter(isNotOut, getAllDays(calendar.months)))
  });
};

const allDaysPass = (predicates: DayPredicate[]): (m: CalendarMonth[]) => boolean =>
  R.any(R.compose(R.any(R.allPass(predicates)), calendarModel.getDays));

const hasNotAvailableDaysInMonth = allDaysPass([calendarModel.isNotAvailable, calendarModel.isSelected]);
export const hasNotAvailableDays = <CalendarPredicate>R.compose(hasNotAvailableDaysInMonth, calendarModel.getMonths);

const hasNotSelectedDaysInMonth = allDaysPass([calendarModel.isSelected]);
const allDaysSelected = <CalendarPredicate>R.compose(
  hasNotSelectedDaysInMonth,
  calendarModel.getMonths
);

export const allDaysNotSelected = <CalendarPredicate>R.complement(allDaysSelected);

type GetValidityPeriod = (calendar: Calendar) => ValidityPeriod;
export const getValidityPeriod: GetValidityPeriod = R.prop('validityPeriod');
